import { h } from 'preact';
import React, { Component } from 'react';
import SearchSVG from '../Components/Search.svg';
import Accordion from '../Components/Accordion';
import { VendorContent } from './VendorContent';
import { makeText } from '../../../util';
import { lockedVendors } from '../../../constants';

export default class Vendors extends Component {
  state = {
    filter: ''
  }

  updateFilter = (e) => this.setState({ filter: e.target.value });

  render() {
    const { vendors, settings, language, dev, toggleVendor, usePurModel, idfaStatus, neutralPm } = this.props;
    const { filter } = this.state;
    const filteredVendors = vendors.filter(v => filter === '' || v.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0);

    const searchText = makeText(Boolean(dev), settings, 'searchText', language);

    const otherText = makeText(Boolean(dev), settings, 'otherText', language);
    const otherLetter = makeText(Boolean(dev), settings, 'otherLetter', language);

    const appleDataBrokerText = makeText(Boolean(dev), settings, 'appleDataBrokerText', language);
    const appleDataBrokerLetter = makeText(Boolean(dev), settings, 'appleDataBrokerLetter', language);
    const isAnyAppleDataBroker = Boolean(filteredVendors.some(v => v.isApple));
    const appleTrackingRejected = (idfaStatus === 'unknown' || idfaStatus === 'denied');

    const customVendorLabel1Text = makeText(Boolean(dev), settings, 'customVendorLabel1Text', language);
    const customVendorLabel2Text = makeText(Boolean(dev), settings, 'customVendorLabel2Text', language);
    const customVendorLabel3Text = makeText(Boolean(dev), settings, 'customVendorLabel3Text', language);
    const customVendorLabel1Letter = makeText(Boolean(dev), settings, 'customVendorLabel1Letter', language);
    const customVendorLabel2Letter = makeText(Boolean(dev), settings, 'customVendorLabel2Letter', language);
    const customVendorLabel3Letter = makeText(Boolean(dev), settings, 'customVendorLabel3Letter', language);

    const isAnyCustomVendorLabel1 = Boolean(filteredVendors.some(v => v.isCustomVendorLabel1));
    const isAnyCustomVendorLabel2 = Boolean(filteredVendors.some(v => v.isCustomVendorLabel2));
    const isAnyCustomVendorLabel3 = Boolean(filteredVendors.some(v => v.isCustomVendorLabel3));
    return (
      <div className="pm-features">
        <div className="filter-container">
          <img src={SearchSVG} alt="" />
          <label style={{ display: 'none' }} for="search">{searchText}</label>
          <input id="search" className="vendor-filter" placeholder={`${searchText}...`} name="filter" value={filter} onChange={this.updateFilter} />
        </div>
        <div className="legend">
          <span className="legend-key" aria-hidden>
            {otherLetter}
          </span>
          <h2 class="custom-header">
            {otherText}
          </h2>
          {isAnyAppleDataBroker && (
            <span className="legend-key apple-broker" aria-hidden>
              {appleDataBrokerLetter}
            </span>
          )}
          {isAnyAppleDataBroker && appleDataBrokerText}

          {isAnyCustomVendorLabel1 && (
            <span className="legend-key is-custom-vendor-label-1" aria-hidden>
              {customVendorLabel1Letter}
            </span>
          )}
          {isAnyCustomVendorLabel1 && customVendorLabel1Text}
          {isAnyCustomVendorLabel2 && (
            <span className="legend-key is-custom-vendor-label-2" aria-hidden>
              {customVendorLabel2Letter}
            </span>
          )}
          {isAnyCustomVendorLabel2 && customVendorLabel2Text}
          {isAnyCustomVendorLabel3 && (
            <span className="legend-key is-custom-vendor-label-3" aria-hidden>
              {customVendorLabel3Letter}
            </span>
          )}
          {isAnyCustomVendorLabel3 && customVendorLabel3Text}
        </div>
        {filteredVendors.map(v => {
          const canToggle = v.disclosureOnlyCategories.length > 0 && v.legIntCategories <= 0 && v.consentCategories <= 0 ? false : true;
          const specialToggle = (v.iabSpecialPurposes.length > 0 || v.iabFeatures.length > 0) && v.consentCategories <= 0 && v.legIntCategories.length <= 0 && v.iabSpecialFeatures <= 0 ? true : false;
          const isApple = v.isApple;
          const isCustomVendorLabel1 = v.isCustomVendorLabel1;
          const isCustomVendorLabel2 = v.isCustomVendorLabel2;
          const isCustomVendorLabel3 = v.isCustomVendorLabel3;
          const hideAppleToggle = isApple && appleTrackingRejected;

          return (
            <Accordion
              key={`vendor-${v.vendorId}`}
              settings={this.props.settings}
              name={(
                <span>
                  <span role="text">
                    {v.name}
                  </span>
                  {v.vendorType !== 'IAB' && (
                    <span className="legend-key inline" aria-hidden>
                      {otherLetter}
                    </span>
                  )}
                </span>
              )}
              isCustom={v.vendorType !== 'IAB'}
              locked={lockedVendors.includes(v.iabId) || hideAppleToggle}
              description={v.name}
              child="vendors"
              language={language}
              value={v}
              content={(
                <VendorContent
                  dev={dev}
                  vendor={v}
                  settings={settings}
                  language={language}
                  toggleVendor={toggleVendor}
                  usePurModel={usePurModel}
                  hideAppleToggle={hideAppleToggle}
                  neutralPm={neutralPm}
                />
              )}
              toggle={canToggle && !specialToggle ? this.props.toggleVendor : null}
              isApple={isApple}
              isCustomVendorLabel1={isCustomVendorLabel1}
              isCustomVendorLabel2={isCustomVendorLabel2}
              isCustomVendorLabel3={isCustomVendorLabel3}
              appleDataBrokerLetter={appleDataBrokerLetter}
              customVendorLabel1Letter={customVendorLabel1Letter}
              customVendorLabel2Letter={customVendorLabel2Letter}
              customVendorLabel3Letter={customVendorLabel3Letter}
              usePurModel={usePurModel}
              neutralPm={neutralPm}
            />
          );
        }
        )}
      </div>
    );
  }
}
